import React from 'react';
import { MapPin, Mail, Clock } from 'lucide-react';
import { companyInfo } from '../mockData';

const ContactUs = () => {
  return (
    <section id="contact" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            Get In Touch
          </h2>
          <div className="w-24 h-1 bg-blue-600 mx-auto mb-6"></div>
          <p className="text-lg text-slate-600 leading-relaxed">
            Have questions or ready to start your next project? We're here to help. 
            Reach out to us through any of the following channels.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          {/* Contact Information */}
          <div className="space-y-8">
            <div>
              <h3 className="text-2xl font-bold text-slate-900 mb-6">Contact Information</h3>
              
              <div className="space-y-6">
                {/* Address */}
                <div className="flex items-start gap-4 bg-slate-50 p-6 rounded-xl">
                  <div className="flex-shrink-0">
                    <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center">
                      <MapPin className="text-white" size={24} />
                    </div>
                  </div>
                  <div>
                    <div className="font-semibold text-slate-900 mb-1">Visit Us</div>
                    <div className="text-slate-600">{companyInfo.contact.address}</div>
                  </div>
                </div>

                {/* Email */}
                <div className="flex items-start gap-4 bg-slate-50 p-6 rounded-xl">
                  <div className="flex-shrink-0">
                    <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center">
                      <Mail className="text-white" size={24} />
                    </div>
                  </div>
                  <div>
                    <div className="font-semibold text-slate-900 mb-1">Email Us</div>
                    <a 
                      href={`mailto:${companyInfo.contact.email}`}
                      className="text-blue-600 hover:text-blue-700 font-medium break-all"
                    >
                      {companyInfo.contact.email}
                    </a>
                  </div>
                </div>

                {/* Business Hours */}
                <div className="flex items-start gap-4 bg-slate-50 p-6 rounded-xl">
                  <div className="flex-shrink-0">
                    <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center">
                      <Clock className="text-white" size={24} />
                    </div>
                  </div>
                  <div>
                    <div className="font-semibold text-slate-900 mb-1">Business Hours</div>
                    <div className="text-slate-600">
                      <div>Monday - Saturday: 9:00 AM - 6:00 PM</div>
                      <div>Sunday: Closed</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Map Placeholder */}
          <div className="space-y-6">
            <h3 className="text-2xl font-bold text-slate-900">Location</h3>
            <div className="bg-slate-100 rounded-xl overflow-hidden shadow-lg h-96 flex items-center justify-center border-2 border-slate-200">
              <div className="text-center p-8">
                <MapPin className="text-blue-600 mx-auto mb-4" size={48} />
                <div className="text-slate-700 font-semibold mb-2">Find Us Here</div>
                <div className="text-slate-600 text-sm mb-4">{companyInfo.contact.address}</div>
                <a 
                  href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(companyInfo.contact.address)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block px-6 py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-colors"
                >
                  Open in Google Maps
                </a>
              </div>
            </div>

            {/* Additional Info */}
            <div className="bg-slate-900 text-white rounded-xl p-6">
              <h4 className="font-bold text-lg mb-3">Why Choose Us?</h4>
              <ul className="space-y-2 text-sm text-slate-300">
                <li className="flex items-start gap-2">
                  <span className="text-blue-400 mt-1">•</span>
                  <span>Free consultation and quotation within 24 hours</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-blue-400 mt-1">•</span>
                  <span>Dedicated account manager for your projects</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-blue-400 mt-1">•</span>
                  <span>Flexible payment terms for regular clients</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-blue-400 mt-1">•</span>
                  <span>Pan-India delivery with tracking</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;
